class receptKeresoSuggest {

    init(el, v2 = false) {
        $(el).keyup((e) => {
            if (e.keyCode == 27) {
                $('.receptkereso-suggest-backlayer').trigger('click')
            }

            if (e.keyCode == 13) {
                return true;
            }


            if ($(el).val().length > 2 && !$(el).hasClass('has-value')) {
                this.openSearchDialog($(el).val(), v2)
                // if ($(''))
            } else {
                $(el).removeClass('has-value');
                $('.keresoform .suggest-content').removeClass('opened').empty();
            }
        })
    }

    openSearchDialog(txt, v2 = false) {

        this.addBGLayer();

        $('.keresoform .suggest-content').empty();
        $('.keresoform .suggest-content .wait-datas').remove();
        $('.keresoform .suggest-content').addClass('opened');
        $('<div>').addClass('wait-datas').appendTo('.keresoform .suggest-content');

        if (window.keresoCSRFToken !== undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-Token': window.keresoCSRFToken
                }
            });
        }
        $.get('/index.php/receptkereso/suggest', { text: txt, mode: v2 ? "v2" : "v1" }, function (res) {
            $('.keresoform .suggest-content').html(res);
        });

    }

    addBGLayer() {
        $('.receptkereso-suggest-backlayer').remove();
        $('<div>')
            .addClass('receptkereso-suggest-backlayer')
            .on("click", function () {
                $('.keresoform .suggest-content').removeClass('opened').empty();
                $('.receptkereso-suggest-backlayer').remove();
            })
            .appendTo('body');

    }

}

export default receptKeresoSuggest;
